export const BLOG_SEO_OVERRIDES = {
  "super-visa-insurance-complicated-doesnt-mean-out-of-reach": {
    title:
      "Why Super Visa Insurance Prices Vary: Age, Health & Costs",
    description:
      "Learn how age, medical history, and deductibles affect Super Visa Insurance pricing and why complexity doesn’t mean rejection.",
    keyphrase: "Super Visa Insurance Prices",
  },

  "build-wealth-in-2026-with-whole-life-insurance-in-canada": {
    title: "Build Wealth With Whole Life Insurance in 2026",
    description:
      "Explore how whole life insurance can support long-term wealth building, tax efficiency, and financial stability for families planning ahead in 2026.",
    keyphrase: "build wealth with whole life insurance",
  },

  "christmas-gifts-that-last-a-lifetime-buy-children-insurance-this-holiday-season":
    {
      title: "Children Insurance as a Christmas Gift That Lasts",
      description:
        "Discover why children insurance is a meaningful Christmas gift, offering lifelong protection, savings growth, and financial security for your child’s future.",
      keyphrase: "children insurance christmas gift",
    },

  "how-fhsa-contributions-reduce-your-taxes-and-boost-your-down-payment": {
    title: "How FHSA Contributions Cut Taxes and Grow Savings",
    description:
      "Learn how FHSA contributions help reduce taxes and grow a stronger down payment, plus key rules and deadlines first-time homebuyers should know.",
    keyphrase: "FHSA reduce taxes",
  },

  "5-reasons-why-your-super-visa-application-in-brampton-can-be-denied": {
    title: "5 Reasons Super Visa Applications Get Denied in Brampton",
    description:
      "Learn the most common reasons Super Visa applications are denied in Brampton and how applicants can avoid mistakes related to insurance, income, and documents.",
    keyphrase: "super visa application denied",
  },

  "why-millennials-and-gen-z-should-consider-critical-illness-insurance-early":
    {
      title: "Why Millennials and Gen Z Need Critical Illness Insurance",
      description:
        "Learn why millennials and Gen Z should consider critical illness insurance early and how it helps protect income, savings, and long-term financial goals.",
      keyphrase: "critical illness insurance for millennials",
    },

  "super-visa-insurance-for-parents-and-grandparents": {
    title: "Super Visa Insurance for Parents and Grandparents Explained",
    description:
      "How Super Visa Insurance works for parents and grandparents, including requirements, coverage rules, and long-stay options.",
    keyphrase: "Super Visa Insurance for Parents",
  },

  "key-benefits-of-term-life-insurance-for-young-families": {
    title: "Key Benefits of Term Life Insurance for Young Families",
    description:
      "Understand how term life insurance helps young families protect income, cover loans, secure children’s education, and gain financial peace of mind.",
    keyphrase: "term life insurance benefits",
  },

  "how-to-use-life-insurance-as-part-of-your-retirement-plan-in-canada": {
    title: "Life Insurance in Retirement Planning Canada",
    description:
      "Add life insurance to your retirement plan in Canada for tax-deferred growth, flexible income options, and estate protection beyond RRSPs and TFSAs.",
    keyphrase: "life insurance retirement plan canada",
  },

  "common-mistakes-to-avoid-when-buying-super-visa-insurance-in-canada": {
    title: "Common Mistakes When Buying Super Visa Insurance",
    description:
      "Avoid costly mistakes when buying Super Visa insurance in Canada. Understand coverage, deductibles, refunds, and IRCC requirements before purchasing.",
    keyphrase: "common mistakes super visa insurance",
  },

  "how-to-use-whole-life-insurance-in-your-financial-planning": {
    title: "How Whole Life Insurance Fits Financial Planning",
    description:
      "See how whole life insurance strengthens financial planning with tax-deferred growth, retirement income options, estate protection, and long-term stability.",
    keyphrase: "whole life insurance financial planning",
  },

  "why-women-need-to-prioritize-life-insurance": {
    title: "Why Women Should Prioritize Life Insurance",
    description:
      "Women face unique financial challenges. See why life insurance is essential for income protection, single mothers, caregivers, and long-term security in Canada.",
    keyphrase: "life insurance for women",
  },

  "life-insurance-for-elderly-in-brampton-a-comprehensive-guide": {
    title: "Guide to Senior Life Insurance in Brampton",
    description:
      "Explore life insurance options for seniors in Brampton. Compare term, whole, and guaranteed plans to protect your family and cover final expenses.",
    keyphrase: "Senior Life Insurance in Brampton",
  },

  "how-life-insurance-can-ease-financial-stress-and-build-wealth": {
    title: "How Life Insurance Builds Wealth in Canada",
    description:
      "Learn how life insurance in Canada can reduce financial stress, build cash value, create tax advantages, and support long-term wealth planning.",
    keyphrase: "Life Insurance Wealth Planning Canada",
  },

  "choosing-the-right-insurance-based-on-your-occupation": {
    title: "Best Insurance Plans by Occupation in Canada",
    description:
      "Find the right insurance based on your occupation. Compare disability, life, critical illness, and business coverage tailored to your career.",
    keyphrase: "Insurance Based on Your Occupation",
  },

  "why-disability-insurance-is-essential-protect-your-income-before-its-too-late":
    {
      title: "Why Disability Insurance Is Essential in Canada",
      description:
        "Protect your paycheck with disability insurance in Canada. Get income replacement coverage to handle expenses if you can’t work due to health issues.",
      keyphrase: "Disability Insurance in Canada",
    },

  "critical-illness-insurance-everything-you-need-to-know": {
    title: "Critical Illness Insurance Explained Canada",
    description:
      "Critical illness insurance in Canada offers a lump sum payout for serious conditions like cancer, stroke, or heart attack.",
    keyphrase: "Critical Illness Insurance in Canada",
  },

  "return-of-premium-on-critical-illness-insurance-get-covered-or-get-your-money-back":
    {
      title: "Critical Illness Insurance with Return Benefit",
      description:
        "Return of premium critical illness insurance gives you a lump sum if diagnosed or refunds 100% of premiums if no claim is made.",
      keyphrase: "Return of Premium Critical Illness Insurance",
    },

  "how-insurance-protects-you-during-lifes-biggest-milestones": {
    title: "How Insurance Protects Life’s Major Milestones",
    description:
      "Insurance for life milestones protects your income, home, and family during marriage, home buying, parenthood, and retirement.",
    keyphrase: "Insurance for Life Milestones",
  },

  "spotlight-on-critical-illness-insurance-is-it-worth-it": {
    title: "Critical Illness Insurance: Is It Worth It?",
    description:
      "Find out if critical illness insurance is worth the investment and how it protects your finances during serious health events.",
    keyphrase: "Is Critical Illness Insurance Worth It",
  },

  "life-insurance-for-millennials-why-its-time-to-start-now": {
    title: "Why Millennials Should Buy Life Insurance",
    description:
      "Millennials in Canada can lock in lower life insurance premiums early and protect future family and financial goals.",
    keyphrase: "Life Insurance for Millennials Canada",
  },

  "canada-pauses-parents-grandparents-sponsorship-program-for-2025-explore-other-options-with-einsured-ca":
    {
      title: "Canada Pauses PGP 2025: Super Visa Options",
      description:
        "Canada pauses Parents & Grandparents Program in 2025. Explore Super Visa insurance options and get cheap quotes online.",
      keyphrase: "Super Visa Insurance Canada",
    },

  "how-life-insurance-can-help-your-family-achieve-long-term-goals": {
    title: "Life Insurance for Long-Term Family Goals",
    description:
      "Secure your family’s future with life insurance designed to support education, debt protection, and long-term financial goals.",
    keyphrase: "Life Insurance for Long-Term Goals",
  },

  "top-insurance-mistakes-to-avoid-in-canada": {
    title: "Top Insurance Mistakes to Avoid in Canada",
    description:
      "Avoid costly insurance mistakes in Canada. Learn how to choose the right life, health, and critical illness coverage for better financial protection.",
    keyphrase: "Insurance Mistakes in Canada",
  },

  "how-contributing-to-a-tfsa-can-boost-your-savings": {
    title: "How a TFSA in Canada Can Boost Your Savings",
    description:
      "Want to grow your savings faster? Learn how a TFSA in Canada offers tax-free growth, flexible withdrawals, and long-term financial benefits.",
    keyphrase: "TFSA in Canada",
  },

  "building-your-childs-future-with-resp-plans-how-small-contributions-make-a-big-difference":
    {
      title: "RESP Plans in Canada: Build Your Child’s Future",
      description:
        "Start saving early with RESP plans in Canada. Discover tax-free growth, CESG grants, and how small contributions make a big impact.",
      keyphrase: "RESP plans in Canada",
    },

  "tax-benefits-of-the-fhsa-how-to-save-on-taxes-while-building-your-down-payment":
    {
      title: "FHSA Canada: Tax Benefits for First-Time Buyers",
      description:
        "Discover the tax benefits of the First Home Savings Account in Canada. Save with tax-deductible contributions and tax-free withdrawals.",
      keyphrase: "First Home Savings Account Canada",
    },

  "how-rrsp-in-canada-can-help-you-save-on-taxes": {
    title: "How RRSP in Canada Helps Reduce Your Taxes",
    description:
      "Learn how RRSP in Canada helps reduce taxable income, grow investments tax-deferred, and build long-term retirement savings.",
    keyphrase: "Tax Benefits of RRSP",
  },

  "super-visa-insurance-what-you-need-to-know-before-applying": {
    title: "Super Visa Insurance Canada: Complete Guide",
    description:
      "Complete guide to Super Visa Insurance in Canada. Compare plans, understand requirements, and get the best coverage for parents.",
    keyphrase: "Super Visa Insurance in Canada",
  },

  "your-guide-to-disability-insurance-quotes-in-canada": {
    title: "Get Disability Insurance Quotes in Canada",
    description:
      "Get a disability insurance quote in Canada and compare coverage options, rates, and benefits to protect your income and financial security.",
    keyphrase: "Disability Insurance Quote Canada",
  },

  "private-mortgage-insurers-vs-banks-what-every-canadian-home-buyer-needs-to-know":
    {
      title: "Private Mortgage Insurers vs Banks: Home Buyer Guide",
      description:
        "Compare private mortgage insurers and banks, what each offers, the impact on your mortgage costs, and key factors every Canadian home buyer should consider.",
      keyphrase: "Private Mortgage Insurers vs Banks",
    },

  "why-its-essential-to-compare-prices-and-policies-from-different-insurance-providers-before-buying-an-insurance-policy":
    {
      title: "Compare Insurance Prices and Policies Before Buying",
      description:
        "Tips to compare insurance prices and policies from different providers to find better coverage, save money, and choose the right plan for your needs.",
      keyphrase: "Compare Insurance Prices and Policies",
    },

  "a-guide-to-health-insurance-in-canada-understanding-your-options": {
    title: "Health Insurance in Canada: Your Coverage Options",
    description:
      "Guide to health insurance in Canada, outlining available coverage choices, what each option includes, and how to select a plan that meets your needs.",
    keyphrase: "Health Insurance in Canada",
  },

  "why-its-crucial-to-follow-government-travel-advisories-insights-for-canadian-travelers":
    {
      title: "Why Government Travel Advisories Matter for Canadians",
      description:
        "Learn why following government travel advisories is crucial for Canadian travellers to stay safe, prepare for risks, and make informed travel decisions.",
      keyphrase: "Government Travel Advisories",
    },

  "7-common-questions-asked-by-super-visa-applicants": {
    title: "7 Questions Super Visa Applicants Often Ask",
    description:
      "7 questions Super Visa applicants frequently ask about eligibility, insurance coverage, documentation, and tips to help make the application process smoother.",
    keyphrase: "Questions Super Visa Applicants",
  },

  "the-crucial-role-of-critical-illness-insurance-for-canadian-professionals": {
    title: "Why Critical Illness Insurance Matters for Professionals",
    description:
      "Critical illness insurance offers essential financial protection for Canadian professionals, helping cover costs & maintain stability if serious health issues arise.",
    keyphrase: "Critical Illness Insurance",
  },

  "the-ultimate-guide-to-understanding-benefits-of-universal-life-insurance-in-canada":
    {
      title: "Universal Life Insurance Benefits in Canada - Full Guide",
      description:
        "A Full guide to universal life insurance benefits in Canada, covering key features, flexibility, wealth growth potential, and how it supports long-term planning.",
      keyphrase: "Universal Life Insurance Benefits",
    },

  "why-should-young-canadians-invest-in-life-insurance": {
    title: "Why Young Canadians Should Invest in Life Insurance",
    description:
      "Why Life insurance helps young Canadians secure financial protection, plan for the future, and lock in lower premiums early for long-term stability.",
    keyphrase: "Canadians Life Insurance",
  },

  "a-comprehensive-guide-to-no-medical-insurance-for-beginners": {
    title: "Comprehensive No Medical Insurance Guide for Beginners",
    description:
      "Learn how no medical insurance exam works, who qualifies, key advantages, and what to consider before choosing this type of life insurance coverage.",
    keyphrase: "No Medical Insurance",
  },

  "the-ultimate-guide-to-travel-insurance-for-your-canadian-adventure": {
    title: "Ultimate Travel Insurance Guide for Your Canada Trip",
    description:
      "Comprehensive travel insurance guidance for your Canadian adventure, covering coverage types, tips for choosing plans, and what to know before you go.",
    keyphrase: "Travel Insurance Guide",
  },

  "why-buy-private-international-medical-insurance-when-studying-in-canada": {
    title: "Why Buy Private Medical Insurance While Studying in Canada",
    description:
      "Understand the benefits of private international medical insurance for students in Canada, including coverage, peace of mind, and financial protection.",
    keyphrase: "Buy Private Medical Insurance",
  },

  "the-complete-guide-to-whole-life-insurance-benefits-in-canada": {
    title: "Whole Life Insurance Benefits in Canada: Complete Guide",
    description:
      "Complete guide to whole life insurance benefits in Canada, covering key advantages, how it works, and why it may fit your long-term financial protection goals.",
    keyphrase: "Whole Life Insurance Benefits",
  },

  "affordable-insurance-solutions-for-super-visa-applicants-in-canada": {
    title: "Affordable Super Visa Insurance Applicants in Canada",
    description:
      "Find affordable insurance solutions for Super Visa applicants in Canada with tips on low-cost plans and how to secure the coverage you need without overspending.",
    keyphrase: "Super Visa Insurance Applicants",
  },

  "comprehensive-guide-to-visitor-insurance-of-parents-for-international-students-in-canada":
    {
      title: "Visitor Insurance for Parents of International Students",
      description:
        "Comprehensive guide to visitor insurance for parents of international students in Canada, with coverage details and tips to ensure protection during their stay.",
      keyphrase: "Visitor Insurance for Parents",
    },

  "how-return-of-premium-enhances-critical-illness-coverage": {
    title: "Return of Premium: Boost Your Critical Illness Coverage",
    description:
      "How the return of premium feature can enhance your critical illness Coverage by returning paid premiums if unused, adding value and stronger financial protection.",
    keyphrase: "Critical Illness Coverage",
  },

  "why-whole-life-insurance-may-not-be-the-right-choice-for-you-exploring-alternatives-in-canada":
    {
      title: "Why Whole Life Insurance Isn’t the Right Choice",
      description:
        "Understand why whole life insurance may not suit your needs and explore alternative life insurance options available in Canada to find the best fit for you.",
      keyphrase: "Whole Life Insurance",
    },

  "ebook-a-simple-guide-to-life-insurance": {
    title: "eBook Life Insurance Guide : Simple & Easy",
    description:
      "Get your simple eBook life insurance guide with clear explanations of key terms, coverage options, and tips to choose the right policy for your needs.",
    keyphrase: "Ebook Life Insurance Guide",
  },

  "unlock-tax-savings-the-power-of-your-rrsp": {
    title: "Tax Savings with the Power of Your RRSP",
    description:
      "Maximize your RRSP power to reduce taxes, grow retirement savings, and boost financial planning with smart contribution strategies for Canadians.",
    keyphrase: "Registered Retirement Savings Plan",
  },

  "how-to-choose-your-first-insurance-plan-and-supercharge-your-financial-portfolio":
    {
      title: "First Insurance Plan and Supercharge Your Financial Portfolio",
      description:
        "How to choose your first insurance plan and supercharge your financial portfolio with smart coverage decisions that support long-term growth.",
      keyphrase: "First Insurance Plan",
    },

  "cut-costs-on-visitors-to-canada-and-super-visa-insurance-with-einsured-ca": {
    title: "How to Cut Costs on Visitor & Super Visa Insurance",
    description:
      "Get tips to reduce costs on visitors to Canada and Super Visa insurance, including ways to find affordable coverage and maximize value for your travel insurance.",
    keyphrase: "Super Visa Insurance",
  },

  "international-students-financial-roadmap": {
    title: "Financial Roadmap for International Students in Canada",
    description:
      "A practical financial roadmap for international students in Canada, covering budgeting, saving, insurance, and essential tips for money management abroad.",
    keyphrase: "International Students in Canada",
  },

  "why-is-life-insurance-important-for-single-parents": {
    title: "Why Life Insurance Matters for Single Parents",
    description:
      "Understand why life insurance is crucial for single parents to protect their children’s financial future, cover expenses, and provide long-term security.",
    keyphrase: "Life Insurance",
  },

  "my-term-life-insurance-is-expiring-now-what-are-my-options": {
    title: "Options When Your Term Life Insurance Is Expiring",
    description:
      "Find out your options when term life insurance is expiring renew your policy, convert to permanent coverage, or choose a new plan that fits your needs.",
    keyphrase: "Term Life Insurance Is Expiring",
  },

  "vital-insights-the-importance-of-maintaining-active-super-visa-insurance-throughout-your-canadian-stay":
    {
      title: "Importance of Maintaining Active Super Visa Insurance",
      description:
        "Why maintaining active Super Visa insurance throughout your Canadian stay is essential for uninterrupted coverage, compliance with requirements, & peace of mind.",
      keyphrase: "Active Super Visa Insurance",
    },

  "why-visitor-insurance-is-a-must-for-parents-visiting-international-students":
    {
      title: "Why visitor insurance is must for parents",
      description:
        "Why visitor insurance is essential for parents visiting international students in Canada, offering health coverage, peace of mind, and financial protection.",
      keyphrase: "Visitor Insurance",
    },

  "a-guide-to-the-first-home-savings-account-building-your-path-to-homeownership":
    {
      title: "First Home Savings Account Canada: FHSA Guide",
      description:
        "A practical guide to Canada’s First Home Savings Account (FHSA), eligibility, benefits, and tips to help you save and plan for your first home purchase.",
      keyphrase: "First Home Savings Account Canada",
    },

  "behind-the-scenes-a-day-in-the-life-of-an-insurance-advisor": {
    title: "Inside a Day in the Life of an Insurance Advisor",
    description:
      "See what an insurance advisor does day-to-day, from client consultations to policy planning, tasks, challenges, and insights into the profession.",
    keyphrase: "Life Insurance Advisor",
  },

  "5-things-we-learned-after-talking-to-hundreds-of-super-visa-clients": {
    title: "5 Key Insights from Hundreds of Super Visa Clients",
    description:
      "5 Key Real insights from hundreds of Super Visa clients on insurance coverage, common questions, mistakes to avoid, and tips that can help future applicants.",
    keyphrase: "Super Visa Clients insurance coverage",
  },

  "answered-what-type-of-life-insurance-may-work-for-you": {
    title: "Which Type of Life Insurance May Work for You",
    description:
      "Review different types of life insurance, how they work, and which option might suit your financial goals, family needs, and long-term planning.",
    keyphrase: "types of life insurance",
  },

  "registered-education-savings-plan-in-canada-a-simple-guide-to-help-you": {
    title: "Registered Education Savings Plan (RESP) in Canada",
    description:
      "Get a simple guide to Registered Education Savings Plan in Canada, how RESPs work, key benefits and tips for saving toward your child’s education.",
    keyphrase: "Registered Education Savings Plan",
  },

  "understanding-the-difference-mortgage-insurance-vs-life-insurance-which-one-do-you-really-need":
    {
      title: "Mortgage Insurance and Life Insurance: What You Need",
      description:
        "Compare mortgage insurance and life insurance to understand their key differences, benefits, and which type might suit your financial protection needs.",
      keyphrase: "Mortgage Insurance and Life Insurance",
    },

  "term-life-insurance-in-canada-definition-advantages-and-factors-to-know-before-you-buy-a-plan":
    {
      title: "Term Life Insurance in Canada: Definition, Benefits & Factor",
      description:
        "Understand term life insurance in Canada with clear definition, key advantages, and essential factors to consider before choosing the right plan for you.",
      keyphrase: "Term Life Insurance in Canada",
    },

  "mortgage-life-insurance-and-disability-insurance-what-are-they": {
    title: "Mortgage Life And Disability Insurance Explained",
    description:
      "Learn mortgage life and disability insurance, how each protects your home loan and income, and which coverage may be right for your financial security.",
    keyphrase: "Mortgage Life and Disability Insurance",
  },

  "super-visa-emergency-medical-insurance-the-key-to-a-worry-free-visit-for-your-parents-and-grandparents":
    {
      title: "Super Visa Emergency Medical Insurance Explained",
      description:
        "Super Visa emergency medical insurance helps ensure your parents’ or grandparents’ visit to Canada is worry-free with the right temporary health coverage.",
      keyphrase: "Super Visa Emergency Medical Insurance",
    },

  "what-options-do-you-have-when-your-term-life-insurance-is-expiring": {
    title: "Term Life Insurance Expiring? Your Available Options",
    description:
      "Find out what happens when your term life insurance expiring and compare renewal, conversion, or replacement options to maintain the right coverage.",
    keyphrase: "Term Life Insurance expiring",
  },

  "5-reliable-key-terms-on-how-to-buy-your-insurance-policy": {
    title: "5 Key Insurance Terms to Know Before You Buy",
    description:
      "Understand 5 key insurance terms that can impact your coverage, costs, and policy benefits before buying an insurance policy in Canada.",
    keyphrase: "5 key insurance terms",
  },

  "a-step-by-step-beginners-guide-to-buy-life-insurance": {
    title: "Step-by-Step Guide to Buy Life Insurance",
    description:
      "A beginner’s guide to buy life insurance with step-by-step tips on choosing coverage, comparing quotes, and securing the right policy for your needs in Canada.",
    keyphrase: "Guide to Buy Life Insurance",
  },

  "how-to-compare-life-insurance-to-get-the-most-for-yourself-and-family": {
    title: "How to Compare Life Insurance Plans for You and Your Family",
    description:
      "Learn how to compare life insurance plans, review coverage options, and find the right policy to protect you and your family’s financial future.",
    keyphrase: "Compare Life Insurance Plans",
  },

  "life-insurance-101": {
    title: "Life Insurance: Essential Guide for Beginners",
    description:
      "Learn life insurance basics, how it works, key types of coverage, and tips to choose the right policy so you can protect your family’s financial future.",
    keyphrase: "Learn life insurance basics",
  },

  "what-is-super-visa-insurance-and-how-much-does-it-cost": {
    title: "Super Visa Insurance Canada: Cost & Coverage Explained",
    description:
      "Learn what Super Visa insurance is, key coverage details, average costs in Canada, and how to choose the right plan for parents or grandparents visiting long-term.",
    keyphrase: "Super Visa Insurance Canada",
  },

  "significance-of-disability-insurance": {
    title: "Why Disability Insurance Matters for Your Financial Security",
    description:
      "Discover the importance of disability insurance, how it protects your income and financial future, and key benefits to consider for peace of mind and security.",
    keyphrase: "Disability Insurance Matters",
  },

  "permanent-life-insurance-1": {
    title: "Permanent Life Insurance Guide: Benefits & Basics",
    description:
      "Learn how permanent life insurance works in Canada, its lifelong coverage benefits, cash value features, and how it compares to term life policies.",
    keyphrase: "Permanent Life Insurance Guide",
  },

  "tips-to-buy-life-insurance-online-the-smart-way": {
    title: "Smart Tips to Buy Life Insurance Online in Canada",
    description:
      "Learn smart tips to buy life insurance online in Canada, compare quotes, choose the right coverage, and avoid costly mistakes when purchasing your policy.",
    keyphrase: "Life Insurance Online in Canada",
  },

  "not-able-to-pay-for-super-visa-insurance-in-full": {
    title: "Monthly Payment Options for Super Visa Insurance",
    description:
      "Explore flexible monthly installment options for Super Visa insurance in Canada and get the required coverage without paying the full premium upfront.",
    keyphrase: "Super Visa insurance in Canada",
  },

  "the-ultimate-super-visa-checklist": {
    title: "Ultimate Super Visa Checklist for Canada Applicants",
    description:
      "Get the ultimate Super Visa checklist for Canada with all required documents, eligibility tips and application steps to help you prepare a successful submission.",
    keyphrase: "Super Visa Checklist for Canada",
  },

  "top-factors-influencing-your-life-insurance-premium": {
    title: "Top Factors Influencing Your Life Insurance Costs",
    description:
      "Explore the top factors influencing your life insurance costs, from age and health to lifestyle and coverage type, and learn how insurers calculate your rates.",
    keyphrase: "Life Insurance Costs",
  },

  "the-crucial-role-of-critical-illness-insurance-for-canadian-professionals-2":
    {
      title: "Critical Illness Insurance for Canadian Professionals",
      description:
        "Why critical illness insurance matters for Canadian professionals, offering vital financial protection and support when serious health issues occur.",
      keyphrase: "Critical Illness Insurance for Canadian",
    },
};
